import React from 'react';
import classNames from 'classnames';
import analyticsTrack from '@lib/analytics/analyticsTrack';
import styles from './UserOpinion.module.scss';

interface UserOpinionProps {
  vendorVariantId?: string;
  opinion?: number;
  className?: string;
  onOpinionChange?: (opinion: number) => void;
}

const LIKE = 1;
const DISLIKE = -1;

const UserOpinion = ({
  vendorVariantId,
  opinion,
  onOpinionChange = () => { },
  className
}: UserOpinionProps) => {
  const handleOpinionClick = (event: React.MouseEvent, newOpinion: number) => {
    event.preventDefault();
    event.stopPropagation();

    analyticsTrack(newOpinion === LIKE ? 'product_liked' : 'product_disliked', {
      vendorVariantId
    });

    if (newOpinion === opinion) {
      onOpinionChange(0); // No longer have an opinion
    } else {
      onOpinionChange(newOpinion);
    }
  };

  return (
    <div className={classNames(styles.UserOpinion, className)}>
      <button
        className={classNames(
          styles.Opinion,
          {
            [styles.Active]: opinion === DISLIKE,
            [styles.Inactive]: opinion === LIKE
          }
        )}
        type="button"
        onClick={(event) => handleOpinionClick(event, DISLIKE)}
      >
        <div>👎</div>
      </button>
      <button
        className={classNames(
          styles.Opinion,
          {
            [styles.Active]: opinion === LIKE,
            [styles.Inactive]: opinion === DISLIKE
          }
        )}
        type="button"
        onClick={(event) => handleOpinionClick(event, LIKE)}
      >
        <div>👍</div>
      </button>
    </div>
  );
};

export default UserOpinion;
